"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Validations = exports.Layout = void 0;
const react_1 = __importDefault(require("react"));
require("./assets/css/bootstrap-grid.min.css");
require("./layout.css");
;
/**
 * Main component.
 * @name layout
 * @param {LayoutProps}
 * @returns {<Layout></Layout>}
*/
const Layout = ({ children }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, children));
};
exports.Layout = Layout;
//utils
var validations_1 = require("./utils/validations");
Object.defineProperty(exports, "Validations", { enumerable: true, get: function () { return __importDefault(validations_1).default; } });
//# sourceMappingURL=layout.js.map